// ======================================================================
// File Name       : LiveReservedDetailRecordedFileList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { LIVE_RECORDING_STATUS_COMPLETED } from '../../constants/UsageSettingLiveConstant';
import { convertBytesToMegaBytes, convertLiveRecordingStatus } from '../../utils/UsageSettingLiveUtils';
import TableHead from '../TableHead';

const thead = [
  { title: '録画開始時刻', sortBy: null },
  { title: '録画終了時刻', sortBy: null },
  { title: 'ファイルサイズ', sortBy: null },
  { title: '処理状況', sortBy: null },
  { title: '操作', sortBy: null, width: 130 },
];

class LiveReservedDetailRecordedFileList extends React.Component {
  render() {
    const {
      userLiveRecordedFileList,
      downloadRecordFile,
    } = this.props;
    let tbody = null;
    if (
      userLiveRecordedFileList &&
      userLiveRecordedFileList.allRecordIds &&
      userLiveRecordedFileList.allRecordIds.length
    ) {
      tbody = userLiveRecordedFileList.allRecordIds.map((recordId, index) => {
        const record = userLiveRecordedFileList.byRecordIds[recordId];
        if (!record) return null;
        return (
          <tr key={index}>
            <td>{record.startTime}</td>
            <td>{record.endTime}</td>
            <td>{convertBytesToMegaBytes(record.fileSize)} MB</td>
            <td>{convertLiveRecordingStatus(record.status)}</td>
            <td>
              <Button
                className="btn-96 btn-edit"
                disabled={parseInt(record.status, 10) !== LIVE_RECORDING_STATUS_COMPLETED}
                onClick={() => {
                  downloadRecordFile(recordId);
                }}
              >
                ダウンロード
              </Button>
            </td>
          </tr>
        );
      });
    }
    return (
      <div className="col-sm-12 padding-left-right-clear padding-top-10">
        <p>録画ファイル</p>
        <p>※ ダウンロード期限はライブ実施日から30日です</p>
        <Table striped hover className="margin-top-10">
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
      </div>
    );
  }
}

export default LiveReservedDetailRecordedFileList;
